// Libraries
import React from "react";
import { useObserver } from "mobx-react-lite";

// Custom
import { IEGridViewCatSubDesc } from "../IETables/IEGridView.CatSubDesc";
import { IEGridViewSubs } from "../IETables/IEGridView.Subs";
import { IEGridViewVariants } from "../IETables/IEGridView.Variants";
import { IEGridTotals } from "../IETables/IEGridView.MasterTotals";
import { IEViewModel } from "../IE.ViewModel";
import { IEItemModalRequest } from "../IEmodels/IEGridModel";
import { IEGridItemModel } from "../IEmodels";
import { PackagesViewModel } from "../PackagesViewModel";
import { VariationGridViewCatSubDesc } from "../VariationTables/VariationGridView.CatSubDesc";
import { GridHeader, SummaryGridView } from "../IETables/IEGrid.Styles";
import { CommercialViewModel } from "../Commercial.ViewModel";
import { PrimaryButton } from "Components/Buttons/Buttons";
import { DarwinTableToolbar } from "Globals/Styles/AppStyling";
import { Grid } from "@shoothill/core";

// Styling & Images

interface ITableProps {
    IEid: string;
    viewModel: IEViewModel;
    packagesViewModel: PackagesViewModel;
    chosenId(id: string): void;
    rowToEdit(iemodel: IEGridItemModel, parent: string, packageItem: IEItemModalRequest): void;
    rowTitle(title: string | undefined): void;
}

export const IETab: React.FunctionComponent<ITableProps> = (props) => {
    const exportCSV = () => {
        props.viewModel.generateCSV(props.IEid);
    };

    return useObserver(() => (
        <div style={{ width: "100%", paddingTop: 22 }}>
            <DarwinTableToolbar>
                {props.viewModel && <PrimaryButton displayName={"Export CSV"} execute={exportCSV} fullWidth={false} canExecute={!props.viewModel.IsLoading} />}
            </DarwinTableToolbar>

            <GridHeader>
                <SummaryGridView>
                    <li className="heading">
                        <div>Category / Sub-category / Line Description</div>
                        <div>Income</div>
                        <div>Target cost</div>
                        <div>Margin %</div>
                        <div>Committed cost</div>
                        <div>Future spend</div>
                        <div>Total expected spend</div>
                        <div>Variance</div>
                        <div>Risk/Opportunity</div>
                        <div></div>
                    </li>
                </SummaryGridView>
            </GridHeader>

            <IEGridViewCatSubDesc
                IEid={props.IEid}
                viewModel={props.viewModel}
                rowToEdit={(row, parent, iePackage) => {
                    props.rowToEdit(row, parent, iePackage);
                }}
                IEType={props.viewModel.ieIsType}
                commercialViewModel={CommercialViewModel.Instance}
                isReport={false}
            />

            <IEGridViewVariants
                chosenId={(i) => {
                    props.chosenId(i);
                }}
                parentId={props.IEid}
                viewModel={props.viewModel}
                packagesViewModel={props.packagesViewModel}
                IEid={props.IEid}
            />

            <IEGridViewSubs
                chosenId={(i) => {
                    props.chosenId(i);
                }}
                parentId={props.IEid}
                viewModel={props.viewModel}
                packagesViewModel={props.packagesViewModel}
                rowTitle={(i) => props.rowTitle(i)}
                IEid={props.IEid}
            />

            <IEGridTotals
                chosenId={(i) => {
                    props.chosenId(i);
                }}
                IEid={props.IEid}
                viewModel={props.viewModel}
                packagesViewModel={props.packagesViewModel}
            />

            <VariationGridViewCatSubDesc
                IEid={props.IEid}
                viewModel={props.viewModel}
                packagesViewModel={props.packagesViewModel}
                // rowToEdit={(row, parent, iePackage) => {
                //     props.rowToEdit(row, parent, iePackage);
                // }}
                IEType={props.viewModel.ieIsType}
            />
        </div>
    ));
};
